import { DRImportTemplate } from "./DRImportConfig";
import React from "react";
import DRImportCard from "./DRImportCard";
import { validateRequiredFields } from "./DRImportFuncs";
import { useAppSelector } from "../../../redux/hooks";
import { RPWDataReader, getDataReader } from "../../../livedataFuncs";


export const DRImport = (props: {drDataRoot: any}) => {
    const livedataRoot: any = useAppSelector((state) => state.currentNavigation.livedataRootContainer?.dataRoot);
    const processor: RPWDataReader = getDataReader(livedataRoot);

    return <>{Object.entries(DRImportTemplate).filter(element => validateRequiredFields(element[1], processor, getDataReader(props.drDataRoot))).map(([secName, secConfig]) => {
        return <DRImportCard secName={secName} secConfig={secConfig} key={secName} drDataRoot={props.drDataRoot} />
    })}
    </> 
}
